import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-international',
  templateUrl: './international.component.html',
  styleUrls: ['./international.component.scss'],
  standalone: false
})
export class InternationalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
